import React, {useContext} from 'react';


// kendo react
import {NumericTextBox} from '@progress/kendo-react-inputs';
import {GeneralContext} from "../FSARequestLicenseContext";


// custom cell and logic for Assign Qty
export const AssignHostQtyCell = (props) => {
    const {
        onePerHostKey
    } = useContext(GeneralContext)

    const field = props.field;
    const dataValue = props.dataItem[field];


    // bound input events and values to the Grid
    const onChange = (ev) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: ev.syntheticEvent,
                value: ev.target.value,
            });
        }
    };

    return (
        <td>
            <NumericTextBox
                className={'ksm-grid-numeric-input'}
                onChange={onChange}
                value={dataValue}
                spinners={false}
                disabled={props.dataItem[onePerHostKey] === "Y"}
                format={{
                    useGrouping: false,
                }}
            />
        </td>
    );
};